import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import MakeContractPanelSub from '../../../widgets/makeContractSubProject/MakeContractPanelSub'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getContractSubProject } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import AttrachContractFilePanel from '../../../widgets/makeContractSubProject/AttrachContractFilePanel'

export default function SubProjectContract() {
  const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isEditWidget, setIsEditWidget] = useState({})

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    }
  }, [projectId])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getContractSubProject(projectVersionId)

      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProject statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms && (
          <>
            {schema?.forms?.agreementDetails && (
              <AgreementAdditionalWidgets formSchema={schema.forms.agreementDetails} />
            )}

            <MakeContractPanelSub
              showCommandButton={true}
              schema={schema.forms.forms}
              isSubProject={true}
              // isEdit={isEditWidget.attachment}
              // onChangeIsEdit={(_isEdit) =>
              //   handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
              // }
            />
            <br />
            <AttrachContractFilePanel showCommandButton={true} schema={schema.forms.forms} />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
